

















import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class BlockContentTwoColumns extends Vue {
  @Prop({ type: String })
  backgroundColor!: string;
}
